// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"41":"error","321":"core","486":"information","818":"auth","860":"menu"}[chunkId] || chunkId) + "-legacy." + {"41":"7b5a76a7","227":"1131cc8c","321":"f7b21bfd","486":"ad0c8826","678":"3966a948","818":"4faabb03","860":"6fe3b09c"}[chunkId] + ".js";
};